import { render } from "./ContentText.vue?vue&type=template&id=ea0d4f98"
import script from "./ContentText.vue?vue&type=script&lang=js"
export * from "./ContentText.vue?vue&type=script&lang=js"

import "./ContentText.vue?vue&type=style&index=0&id=ea0d4f98&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__